import type { ReactNode } from 'react';

type SplitPaneProps = {
  left: ReactNode;
  right: ReactNode;
  /** Ширина левой панели в px. По умолчанию 320. */
  leftWidth?: number;
  /** Мин. ширина левой панели. */
  minLeftWidth?: number;
  /** Граница между панелями. По умолчанию рисуется. */
  divider?: boolean;
};

/**
 * Простой неперетаскиваемый 2-pane контейнер. Левая фиксированной ширины,
 * правая забирает остаток. Обе панели управляют своей прокруткой сами.
 *
 * Если позже понадобится drag-to-resize — добавим тут.
 */
const SplitPane = ({
  left,
  right,
  leftWidth = 320,
  minLeftWidth = 240,
  divider = true,
}: SplitPaneProps) => {
  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '100%',
        minHeight: 0,
        flex: 1,
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: leftWidth,
          minWidth: minLeftWidth,
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          background: 'var(--shell-bg-surface)',
          borderRight: divider ? '1px solid var(--shell-border-subtle)' : 'none',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {left}
      </div>
      <div
        style={{
          flex: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          background: 'var(--shell-bg-surface)',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {right}
      </div>
    </div>
  );
};

export default SplitPane;
